import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';

export const useMultiSelectDropdown = ({
  initialOptions,
  isSingleSelect = false,
}: {
  initialOptions: MultiSelectOption[];
  isSingleSelect?: boolean;
}): {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleOnOptionClicked: (option: MultiSelectOption) => MultiSelectOption[];
  options: MultiSelectOption[];
} => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<MultiSelectOption[]>([]);

  useDeepCompareEffect(() => {
    setOptions(initialOptions);
  }, [initialOptions]);

  const handleOnOptionClicked = (option) => {
    //Check if an option from the same group is already selected
    const isOptionSelected = options.some(
      (o) => o.optionName === option.optionName && o.isSelected,
    );
    const newOptions = options.map((item) => {
      // If the option is already selected and is other than the one clicked, unselected it
      if (
        isOptionSelected &&
        item.optionName === option.optionName &&
        item.id !== option.id
      ) {
        return {
          ...item,
          isSelected: false,
        };
      }
      if (item.id === option.id) {
        return { ...item, isSelected: true };
      } else if (isSingleSelect) {
        return { ...item, isSelected: false };
      }
      return item;
    });
    setOptions(newOptions);
    return newOptions;
  };

  return {
    isOpen,
    setIsOpen,
    handleOnOptionClicked,
    options,
  };
};
